module.exports = __webpack_public_path__ + "static/media/mic.b140c15a.svg";